import { GET_LOG, LOG_ERROR } from '../actions/types';

const initialState = {
    log: [],
    loading: true
}

export default function (state = initialState, action){
    const { type, payload } = action;
    switch(type){
        case GET_LOG:
            return {
                ...state,
                log: payload,
                loading: false
            };
        case LOG_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}
